import React from "react";

/**
 * The header of a card inside Settings' More (#1135), as the approved
 * SettingsPlayer and SettingsCoach boards draw it: a 36px icon tile, the title
 * in Manrope 700 at 16px, and a 13px subtitle. Presentation only. The kit
 * frame around it and the body below it belong to the caller.
 */
export function MoreCardHeader({ icon: Icon, title, subtitle }) {
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
      <div
        style={{
          width: 36,
          height: 36,
          flexShrink: 0,
          borderRadius: 10,
          background: "#E8F1FB",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon size={16} color="#0B2E59" aria-hidden="true" />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 2, minWidth: 0 }}>
        <div style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: 16, color: "#0F172A" }}>{title}</div>
        {subtitle && <div style={{ fontSize: 13, lineHeight: 1.45, color: "#64748B" }}>{subtitle}</div>}
      </div>
    </div>
  );
}

/**
 * A card in More: the kit surface (white, 1px line, 12px radius, 14px padding,
 * no shadow), the board header, then the shipped body as children. Plain divs,
 * never the shipped shadcn Card (journey 65).
 */
export default function SettingsMoreCard({ icon, title, subtitle, children, id, "data-testid": testId }) {
  return (
    <div
      id={id}
      data-testid={testId}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        padding: 14,
        background: "var(--nw-surface)",
        border: "1px solid var(--nw-line)",
        borderRadius: "var(--nw-radius-card)",
      }}
    >
      <MoreCardHeader icon={icon} title={title} subtitle={subtitle} />
      {children}
    </div>
  );
}
